<div class="progress-bar">
    <div class="progress-fill" [style.width.%]="percent"></div>
</div>
